<template>
    <div class='footer'>

        <div class="dasktop" :style="{ 'background-image': `url(${getfront[1]?.img})` }">
            <div class="cont-top">
                <div class="container">
                    <ul class="list-unstyled d-flex" style="justify-content: space-evenly; margin: 0;">
                        <li for="" style="cursor: pointer;" ><router-link to="/about">關於</router-link></li>
                        <li style="cursor: pointer;"><router-link to="/contact_us">聯絡我們</router-link></li>
                        <li for="" style="cursor: pointer;" ><router-link to="/all_category">全部商品</router-link></li>
                        <li><router-link to="/check_order">訂單查詢</router-link></li>
                        <li style="cursor: pointer;" @click="goshopping_instructions('訂單相關說明')"><router-link to="/shopping_instructions">訂單相關說明</router-link></li>
                        <li @click="goshopping_instructions('付款方式說明')" for="" style="cursor: pointer;"><router-link to="/shopping_instructions">付款方式說明</router-link></li>
                        <li style="cursor: pointer;" @click="goshopping_instructions('寄送方式說明')"><router-link to="/shopping_instructions">寄送方式說明</router-link></li>
                        <li style="cursor: pointer;" @click="goshopping_instructions('售後服務說明')"><router-link to="/shopping_instructions">售後服務說明</router-link></li>
                        <li><router-link to="/announcement">防詐騙公告</router-link></li>
                    </ul>

                </div>
            </div>
            <div class="cont-bottom">
                <div class="container d-flex align-items-center">
                    <div class="left d-grid">
                        <span v-for="item in website.company_info"
                            v-if="item.key !== 'FB_Link' && item.key !== 'Line_Link'">
                            <span>{{ item.key }}</span>：
                            <span v-html="item.value"></span>
                        </span>

                    </div>
                    <div class="right">
                        <div v-html="facebook">

                        </div>
                        <ul class="social_list d-flex list-unstyled mb-0" v-if="website.company_info">
                            <li><span v-for="item in website.company_info">
                                    <a class="d-block" v-if="item.key == 'FB_Link'" :href="item.value" target="_blank"><img
                                            class="mw-100" src="@/assets/svg/img_facebook.svg" width="30" height="30"
                                            alt="facebook"></a>
                                </span></li>
                            <li><span v-for="item in website.company_info">
                                    <a class="d-block" v-if="item.key == 'Line_Link'" :href="item.value"
                                        target="_blank"><img class="mw-100" src="@/assets/svg/img_line.svg" width="30"
                                            height="30" alt="line"></a>
                                </span></li>
                            <li>
                                <a class="d-block" href="/" alt="商城首頁" title="商城首頁">
                                    <svg data-name=" 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72"
                                        style="width: 30px;">

                                        <circle class="cls-1" cx="36" cy="36" r="36"></circle>
                                        <path class="cls-2"
                                            d="M41.62,33.6a3.3,3.3,0,0,1-3.25-2.36V18h4.45l2.06,6.44v5.9a3.27,3.27,0,0,1-3.26,3.26Z">
                                        </path>
                                        <path class="cls-2"
                                            d="M30.38,33.6a3.27,3.27,0,0,1-3.26-3.26v-5.9L29.18,18h4.45V30.34a3.26,3.26,0,0,1-3.25,3.26Z">
                                        </path>
                                        <path class="cls-2"
                                            d="M19.14,33.6a3.27,3.27,0,0,1-3.26-3.26V24.66L19.43,18h4.78l-1.82,5.7v6.64a3.26,3.26,0,0,1-3.25,3.26Z">
                                        </path>
                                        <path class="cls-2" d="M32.41,45.91h7.31V54H32.41Z"></path>
                                        <path class="cls-2"
                                            d="M44.45,54V43.54a2.37,2.37,0,0,0-2.36-2.37H30a2.37,2.37,0,0,0-2.37,2.37V54H21.94a1.64,1.64,0,0,1-1.64-1.65V38.24A8,8,0,0,0,24.76,36h0a8,8,0,0,0,11.18.06h0s.09.08.13.13a8.27,8.27,0,0,0,5.55,2.13h0A7.86,7.86,0,0,0,47.24,36h0a8,8,0,0,0,4.42,2.23h0v14.1A1.65,1.65,0,0,1,50.06,54H44.45Z">
                                        </path>
                                        <path class="cls-2"
                                            d="M52.86,33.6a3.26,3.26,0,0,1-3.25-3.26V23.7L47.79,18H52.6c1.68,3,3.07,5.61,3.52,6.53v5.81a3.27,3.27,0,0,1-3.26,3.26Z">
                                        </path>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>
                <div class="container"
                    style="padding-left: 90px!important;padding-right: 90px!important;text-align: center;">
                    <span data-v-dc17706c="" style="color: blue;font-size: 14px;">
                        <span style="cursor: pointer;" ><router-link to="/privacy_Policy" style="color: #0000FF;">隱私權條款</router-link></span> | <span style="cursor: pointer;" ><router-link to="/consumer_Rights" style="color: #0000FF;">消費者權益</router-link></span> | <span style="cursor: pointer;" ><router-link to="/terms_Service" style="color: #0000FF;">會員服務條款</router-link></span></span>
                </div>
            </div>
        </div>
        <div class="mobile" :style="{ 'background-image': `url(${getfront[1]?.img})` }">
            <div class="cont-top">
                <div class="container  mb-0 align-items-center">
                    <div class="left d-flex">
                        <div class="text d-grid">
                            <span v-for="item in website.company_info"
                                v-if="item.key !== 'FB_Link' && item.key !== 'Line_Link'">
                                <span>{{ item.key }}</span>：
                                <span v-html="item.value"></span>
                            </span>

                        </div>
                    </div>
                    <div class="right">
                        <div class="link">
                            <div class="title  item ">
                                <input id="mobileinp1" class="inp d-none" type="checkbox" aria-label="展开">
                                <label for="" style="cursor: pointer;"><router-link to="/about">關於</router-link></label>
                                <ul class="list-unstyled">
                                    <li style="cursor: pointer;" ><router-link to="/contact_us">聯絡我們</router-link></li>
                                    <li><router-link to="/announcement">防詐騙公告</router-link></li>
                                </ul>
                            </div>
                            <div class="title  item ">
                                <input id="mobileinp2" class="inp d-none" type="checkbox" aria-label="展开">
                                <label for="" style="cursor: pointer;" ><router-link to="/all_category">全部商品</router-link></label>
                                <ul class="list-unstyled">
                                    <li><router-link to="/check_order">訂單查詢</router-link></li>
                                    <li style="cursor: pointer;" @click="goshopping_instructions('訂單相關說明')"><router-link to="/shopping_instructions">訂單相關說明</router-link></li>
                                </ul>
                            </div>
                            <div class="title  item ">
                                <input id="mobileinp3" class="inp d-none" type="checkbox" aria-label="展开">
                                <label @click="goshopping_instructions('付款方式說明')" for=""
                                    style="cursor: pointer;"><router-link to="/shopping_instructions">付款方式說明</router-link></label>
                                <ul class="list-unstyled">
                                    <li style="cursor: pointer;" @click="goshopping_instructions('寄送方式說明')"><router-link to="/shopping_instructions">寄送方式說明</router-link></li>
                                    <li style="cursor: pointer;" @click="goshopping_instructions('售後服務說明')"><router-link to="/shopping_instructions">售後服務說明</router-link></li>
                                </ul>
                            </div>
                        </div>
                        <div class="icon">
                            <div v-html="facebook"></div>
                            <ul class="social_list d-flex list-unstyled mb-0" v-if="website.company_info">
                                <li><span v-for="item in website.company_info">
                                        <a class="d-block" v-if="item.key == 'FB_Link'" :href="item.value"
                                            target="_blank"><img class="mw-100" src="@/assets/svg/img_facebook.svg"
                                                width="30" height="30" alt="facebook"></a>
                                    </span></li>
                                <li><span v-for="item in website.company_info">
                                        <a class="d-block" v-if="item.key == 'Line_Link'" :href="item.value"
                                            target="_blank"><img class="mw-100" src="@/assets/svg/img_line.svg" width="30"
                                                height="30" alt="line"></a>
                                    </span></li>
                                <li>
                                    <a class="d-block" href="/" alt="商城首页" title="商城首页">
                                        <svg data-name=" 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72"
                                            style="width: 30px;">

                                            <circle class="cls-1" cx="36" cy="36" r="36"></circle>
                                            <path class="cls-2"
                                                d="M41.62,33.6a3.3,3.3,0,0,1-3.25-2.36V18h4.45l2.06,6.44v5.9a3.27,3.27,0,0,1-3.26,3.26Z">
                                            </path>
                                            <path class="cls-2"
                                                d="M30.38,33.6a3.27,3.27,0,0,1-3.26-3.26v-5.9L29.18,18h4.45V30.34a3.26,3.26,0,0,1-3.25,3.26Z">
                                            </path>
                                            <path class="cls-2"
                                                d="M19.14,33.6a3.27,3.27,0,0,1-3.26-3.26V24.66L19.43,18h4.78l-1.82,5.7v6.64a3.26,3.26,0,0,1-3.25,3.26Z">
                                            </path>
                                            <path class="cls-2" d="M32.41,45.91h7.31V54H32.41Z"></path>
                                            <path class="cls-2"
                                                d="M44.45,54V43.54a2.37,2.37,0,0,0-2.36-2.37H30a2.37,2.37,0,0,0-2.37,2.37V54H21.94a1.64,1.64,0,0,1-1.64-1.65V38.24A8,8,0,0,0,24.76,36h0a8,8,0,0,0,11.18.06h0s.09.08.13.13a8.27,8.27,0,0,0,5.55,2.13h0A7.86,7.86,0,0,0,47.24,36h0a8,8,0,0,0,4.42,2.23h0v14.1A1.65,1.65,0,0,1,50.06,54H44.45Z">
                                            </path>
                                            <path class="cls-2"
                                                d="M52.86,33.6a3.26,3.26,0,0,1-3.25-3.26V23.7L47.79,18H52.6c1.68,3,3.07,5.61,3.52,6.53v5.81a3.27,3.27,0,0,1-3.26,3.26Z">
                                            </path>
                                        </svg>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cont-bottom">
                <div class="container"
                    style="padding-left: 90px!important;padding-right: 90px!important;text-align: center;">
                    <span data-v-dc17706c="" style="color: blue;font-size: 14px;">
                        <span style="cursor: pointer;" ><router-link to="/privacy_Policy" style="color: #0000FF;">隱私權條款</router-link></span> | <span style="cursor: pointer;" ><router-link to="/consumer_Rights" style="color: #0000FF;">消費者權益</router-link></span> | <span style="cursor: pointer;" ><router-link to="/terms_Service"  style="color: #0000FF;">會員服務條款</router-link></span></span>
                </div>
            </div>
        </div>
        <ul class="fixed_list d-flex list-unstyled mb-0" v-if="website.company_info" style="justify-content: center;">
            <li style="padding: 10px;"><span v-for="item in website.company_info">
                    <a v-if="item.key == 'FB_Link'" :href="item.value" target="_blank"><img class="mw-100"
                            src="@/assets/svg/img_facebook.svg" alt="facebook"></a>
                </span></li>
            <li style="padding: 10px;"><span v-for="item in website.company_info">
                    <a v-if="item.key == 'Line_Link'" :href="item.value" target="_blank"><img class="mw-100"
                            src="@/assets/svg/img_line.svg" alt="line"></a>
                </span></li>
        </ul>

    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    components: {},
    data() {
        return {
            faceicon: '<iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D100084883113999&tabs&width=330&height=70&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="330" height="70" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>',
            face: '',
            link: '',
            desktop_img: 'https://hinetcdn.waca.ec/uploads/shops/25040/theme/b1/b1de04e7595d01faca3dc97c90ba82e7.jpg?v=202307071211'
        };
    },
    computed: {
        ...mapState('header', ['website', 'getfront', 'facebook']),
    },
    watch: {},
    methods: {
        // 关于
        go() {
            this.$router.push({ path: `/about` }).catch(err => { });
        },
        // 联络我们
        gous() {
            this.$router.push({ path: `/contact_us` }).catch(err => { });
        },
        // 所有商品
        goall() {
            this.$router.push({ path: `/all_category` }).catch(err => { });
        },
        // 说明
        goshopping_instructions(e) {
            if (`/shopping_instructions` == this.$route.path) {
                //如果当前已经在这个页面不跳转 直接去 
                let toElement = document.getElementById(e);
                toElement.scrollIntoView(true);
            } else {
                //否则跳转路由 
                localStorage.setItem("toId", e);
                //this.$router.push({ path: `/shopping_instructions` });
            }

        },
        // 隐私权条款
        go_pp() {
            this.$router.push({ path: `/privacy_Policy` }).catch(err => { });
        },
        // 消费者权益
        go_cr() {
            this.$router.push({ path: `/consumer_Rights` }).catch(err => { });
        },
        // 会员服务条款
        go_ts() {
            this.$router.push({ path: `/terms_Service` }).catch(err => { });
        },
    },
    created() {
    },
    mounted() {
    },
}
</script>
<style lang='scss' scoped src="./index.scss"></style>